// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner_loader__aB8hr {
  color: rgb(25, 118, 210);
  font-size: 10px;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: spinner_mulShdSpin__JiIOt 1.3s infinite linear;
  transform: translateZ(0);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
}

.spinner_logo__97CjX {
  width: 1.5em;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
}

@keyframes spinner_mulShdSpin__JiIOt {
  0%, 100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/LoadingScreen/spinner.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yDAAA;EACA,wBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;AACF;;AAEA;EAEE,YAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;AAAF;;AAGA;EAEE;IAEE,qIAAA;EAFF;EASA;IACE,mIAAA;EAPF;EAaA;IACE,qIAAA;EAXF;EAkBA;IACE,yIAAA;EAhBF;EAqBA;IACE,uIAAA;EAnBF;EAwBA;IACE,mIAAA;EAtBF;EA2BA;IACE,yIAAA;EAzBF;EA8BA;IACE,oIAAA;EA5BF;AACF","sourcesContent":[".loader {\n  color: rgba(25, 118, 210, 1);\n  font-size: 10px;\n  width: 2em;\n  height: 2em;\n  border-radius: 50%;\n  position: relative;\n  text-indent: -9999em;\n  animation: mulShdSpin 1.3s infinite linear;\n  transform: translateZ(0);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10000000;\n}\n\n.logo {\n  // height: 200px;\n  width: 1.5em;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10000000;\n}\n\n@keyframes mulShdSpin {\n\n  0%,\n  100% {\n    box-shadow: 0 -3em 0 0.2em,\n      2em -2em 0 0em, 3em 0 0 -1em,\n      2em 2em 0 -1em, 0 3em 0 -1em,\n      -2em 2em 0 -1em, -3em 0 0 -1em,\n      -2em -2em 0 0;\n  }\n\n  12.5% {\n    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em,\n      3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em,\n      -2em 2em 0 -1em, -3em 0 0 -1em,\n      -2em -2em 0 -1em;\n  }\n\n  25% {\n    box-shadow: 0 -3em 0 -0.5em,\n      2em -2em 0 0, 3em 0 0 0.2em,\n      2em 2em 0 0, 0 3em 0 -1em,\n      -2em 2em 0 -1em, -3em 0 0 -1em,\n      -2em -2em 0 -1em;\n  }\n\n  37.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\n      3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em,\n      -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;\n  }\n\n  50% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\n      3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em,\n      -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;\n  }\n\n  62.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\n      3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0,\n      -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;\n  }\n\n  75% {\n    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em,\n      3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em,\n      -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;\n  }\n\n  87.5% {\n    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em,\n      3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em,\n      -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `spinner_loader__aB8hr`,
	"mulShdSpin": `spinner_mulShdSpin__JiIOt`,
	"logo": `spinner_logo__97CjX`
};
export default ___CSS_LOADER_EXPORT___;
